import Component from './signIn'

export default Component